import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/core/services/toast.service';
import { dateOfNextMonth } from 'src/app/shared/constants/date-format';
import { VariableValueDto } from 'src/app/shared/dto/variable-value.dto';
import { VariableValueService } from 'src/app/shared/http-services/variable-value.service';
import { Allowance } from 'src/app/shared/models/allowance.model';
import { formatDate } from 'src/app/shared/utils/utils-global';
import { Nullable } from '../../constants/types';

@Component({
  selector: 'app-allowance-variable',
  templateUrl: './allowance-variable.component.html',
  styleUrls: ['./allowance-variable.component.scss'],
})
export class AllowanceVariableComponent implements OnInit {
  public readonlyAllowances: Allowance[] = [];
  public editableAllowances: Allowance[] = [];
  public startingOn = dateOfNextMonth();
  public minDate = dateOfNextMonth();
  @Input() public currentSiteId: Nullable<number> = 0;
  @Input() public set allowances(allowances: Allowance[]) {
    this.readonlyAllowances = [];
    this.editableAllowances = [];
    allowances.forEach(v => {
      if (v.isCurrentApplicable) {
        this.readonlyAllowances.push(v);
      }
      if (v.isFutureApplicable) {
        this.editableAllowances.push(v);
      }
    });
    if (!this.editableAllowances.length) {
      this.editableAllowances = JSON.parse(
        JSON.stringify(this.readonlyAllowances),
      );
      this.editableAllowances = this.editableAllowances.map((v: Allowance) => {
        v.value = 0;
        v.isCurrentApplicable = false;
        v.isFutureApplicable = true;
        return new Allowance(v);
      });
    }
    if (
      this.editableAllowances.length &&
      this.editableAllowances[0].validFrom
    ) {
      const newStartingOn = new Date(this.editableAllowances[0].validFrom);
      if (newStartingOn > this.startingOn) {
        this.startingOn = new Date(this.editableAllowances[0].validFrom);
      }
    }
  }
  constructor(
    private variableValueService: VariableValueService,
    private translateService: TranslateService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {}

  public onEdit(): void {
    const value: VariableValueDto[] = this.editableAllowances.map(v => {
      return {
        variableId: v.variableId,
        homebaseId: this.currentSiteId,
        value: +v.value,
        validFrom: formatDate(this.startingOn),
      };
    });

    this.variableValueService.updateVariableValue(value).subscribe(res => {
      if (res.code < 0) {
        const message = this.translateService.instant(res.data);
        this.toastService.showWarn(message);
      } else {
        this.startingOn = new Date(res.data);
        const message = this.translateService.instant(
          'UPDATE_VARIABLE_SUCCESSFUL',
        );
        this.toastService.showSuccess(message);
      }
    });
  }
}
